import { ImCross, ImTruck } from 'react-icons/im'
import { MdAccessTimeFilled } from 'react-icons/md'
import styles from './PopupDelivery.module.css'
import {
  useGetClientDeliveriesQuery,
  useGetClientOrderDocMutation,
} from '../../../redux/clientData/apiClientData'
import Loader from '../../loader/Loader'
import { useState } from 'react'
import { toast } from 'react-toastify'

function DeliveryCard({ time, sales, onDocClick }) {
  const displayTime = time.includes(':') ? time.slice(0, 5) : time

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <MdAccessTimeFilled className={styles.cardIcon} />
        <span className={styles.cardHeaderText}>Виїзд о {displayTime}</span>
      </div>

      <div className={styles.cardContent}>
        {sales.length > 0 ? (
          <div className={styles.deliveredDocs}>
            Відвантажені накладні:{' '}
            {sales.map((el, i) => (
              <span
                className={styles.docText}
                key={i}
                onClick={() => onDocClick(el.docID, el.sum)}
              >
                №{el.docID}
                {i < sales.length - 1 ? ', ' : ''}
              </span>
            ))}
          </div>
        ) : (
          <div className={styles.noSalesText}>Відвантаження відсутні.</div>
        )}
      </div>
    </div>
  )
}

function OrderDocModal({ docID, docData, docSum, onClose, loadingDoc }) {
  if (loadingDoc) return <Loader />

  return (
    <div className="overlayCont" onClick={onClose}>
      <div
        className={styles.modalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalHeader}>
          <div>Накладна № {docID}</div>
          <div className={styles.closeIcon} onClick={onClose}>
            <ImCross />
          </div>
        </div>

        <table className={styles.historyOrderTable}>
          <thead>
            <tr>
              <th>Звідки</th>
              <th>Бренд</th>
              <th>Номер</th>
              <th>Опис</th>
              <th>Ціна</th>
              <th>Кількість</th>
              <th>Сума</th>
            </tr>
          </thead>
          <tbody>
            {docData.orderDoc.map((spare, i) => (
              <tr key={i}>
                <td>
                  {spare.isExternalOrder ? 'Під замовлення' : 'Наявність'}
                </td>
                <td>{spare.brand}</td>
                <td>{spare.spareCode}</td>
                <td>{spare.description}</td>
                <td>{parseFloat(spare.price).toFixed(2)}</td>
                <td>{spare.qty}</td>
                <td>{(parseFloat(spare.price) * spare.qty).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <hr className={styles.modalHR} />
        <div className={styles.docSumContainer}>Всього: {docSum}</div>
      </div>
    </div>
  )
}

function PopupDelivery({ togglePanel, isPanelOpen }) {
  const { data: clientDeliveries, isLoading: isLoadingDeliveries } =
    useGetClientDeliveriesQuery()

  const [getOrderDoc, { isLoading: loadingDoc }] =
    useGetClientOrderDocMutation()

  const [isShowDoc, setIsShowDoc] = useState(false)
  const [selectedDocID, setSelectedDocID] = useState(null)
  const [docData, setDocData] = useState({ orderDoc: [] })
  const [docSum, setDocSum] = useState(0)

  const handleShowOrderDoc = async (docID, sum) => {
    try {
      const res = await getOrderDoc({ docID }).unwrap()
      setDocData(res)
      setSelectedDocID(docID)
      setDocSum(sum)
      setIsShowDoc(true)
    } catch {
      toast.error('Не вдалося завантажити документ')
    }
  }

  const handleCloseModal = () => {
    setIsShowDoc(false)
    setSelectedDocID(null)
    setDocData({ orderDoc: [] })
    setDocSum(0)
  }

  const times = Object.keys(clientDeliveries?.salesByDelivery ?? [])

  return (
    <>
      <div className={`${styles.popupPanel} ${isPanelOpen ? styles.open : ''}`}>
        <div className={styles.popupHeader}>
          <div className={styles.headerTitle}>
            <ImTruck className={styles.truckIcon} />

            <span className={styles.headerText}>Доставки</span>
          </div>
          <span onClick={togglePanel} className={styles.closeIcon}>
            <ImCross />
          </span>
        </div>
        <div className={styles.popupPanelContent}>
          {isLoadingDeliveries ? (
            <Loader />
          ) : (
            <div>
              {times.length > 0
                ? times?.map((time, i) => {
                    return (
                      <DeliveryCard
                        time={time}
                        sales={clientDeliveries?.salesByDelivery[time]}
                        key={i}
                        onDocClick={handleShowOrderDoc}
                      />
                    )
                  })
                : null}
            </div>
          )}
        </div>
      </div>
      {isShowDoc && (
        <OrderDocModal
          docID={selectedDocID}
          docData={docData}
          docSum={docSum}
          onClose={handleCloseModal}
          loadingDoc={loadingDoc}
        />
      )}
      {times.length > 0 ? (
        <div className={styles.popupButton} onClick={togglePanel}>
          <ImTruck />
        </div>
      ) : null}
    </>
  )
}

export default PopupDelivery
